/**
 * @generated SignedSource<<a1eddf772fccaadbf469fd3eb2913766>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemListEntry_component$data = {
  readonly id: string;
  readonly indent: string | null | undefined;
  readonly info: string | null | undefined;
  readonly label: string | null | undefined;
  readonly value: string | null | undefined;
  readonly valueInfo: string | null | undefined;
  readonly " $fragmentType": "ItemListEntry_component";
};
export type ItemListEntry_component$key = {
  readonly " $data"?: ItemListEntry_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemListEntry_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemListEntry_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "indent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueInfo",
      "storageKey": null
    }
  ],
  "type": "ItemListEntry",
  "abstractKey": null
};

(node as any).hash = "99bda037a3c3585182952025bcc1c164";

export default node;
